<div class="dashboard-container">
  <main class="dashboard-content">
    <div class="top-grid">
      <div class="kpi-hero" [hidden]="!loading() && !chartLoading() && chartSignal().length === 0">
        <div class="card main-kpi billings-chart-card">
          <div
            #chartContainer
            class="billings-chart-container"
            [hidden]="loading() || chartLoading() || chartSignal().length === 0"
          ></div>
          @if (loading() || chartLoading()) {
            <div class="billings-chart-skeleton" aria-busy="true">
              <p-skeleton width="100%" height="100%" borderRadius="4px" />
            </div>
          }
        </div>
      </div>
      @if (!loading() && !chartLoading() && chartSignal().length === 0) {
        <div class="empty-insight">
          <lucide-icon name="trending-down" [size]="36"></lucide-icon>

          <h3>No hay datos de liquidaciones en este periodo</h3>

          <p>No se han encontrado registros para las fechas seleccionadas.</p>

          <div class="suggestions">
            <span>
              <lucide-icon name="lightbulb" [size]="16"></lucide-icon>
              Sugerencias:</span
            >
            <ul>
              <li>Modifica el rango de fechas</li>
              <li>Prueba con un intervalo más amplio</li>
              <li>Contacta con un administrador si el problema persiste</li>
            </ul>
          </div>
        </div>
      }

      @if (loading()) {
        <div class="side-panel-2 config-skeleton" aria-busy="true">
          <div class="config-skeleton-header">
            <p-skeleton shape="circle" size="20px" />
            <p-skeleton width="65%" height="16px" />
          </div>
          <div class="config-skeleton-section">
            <p-skeleton width="55%" height="12px" styleClass="mb-2" />
            <p-skeleton width="100%" height="38px" borderRadius="6px" />
          </div>
          <div class="config-skeleton-date-block">
            <p-skeleton width="65%" height="16px" styleClass="mb-3" />
            <p-skeleton width="100%" height="38px" borderRadius="6px" />
          </div>
          <div class="config-skeleton-summary">
            <p-skeleton width="65%" height="16px" styleClass="mb-3" />
            @for (row of [1, 2, 3, 4]; track row) {
              <div class="config-skeleton-summary-row" aria-hidden="true">
                <p-skeleton width="70%" height="12px" />
                <p-skeleton width="80px" height="14px" />
              </div>
            }
          </div>
          <div class="config-skeleton-footer">
            <p-skeleton width="100%" height="34px" borderRadius="4px" />
            <p-skeleton width="100%" height="34px" borderRadius="4px" />
          </div>
        </div>
      } @else {
        <div class="side-panel-2">
          <div class="config-container" [formGroup]="configForm">
            <header class="panel-header">
              <lucide-icon name="Settings2" [size]="20"></lucide-icon>
              <h3>Panel de configuración</h3>
            </header>
            <section class="form-section">
              @if (isGGM() && homeData()?.hasElectronicSettlement == false) {
                <div class="recibo-verde-card">
                  <div class="card-body">
                    <div class="logo-wrapper">
                      <img src="assets/img/logo_recibo_verde_sv_solo.svg" alt="ReciboVerde" />
                    </div>

                    <div class="info-text">
                      <span class="hashtag">ReciboVerde</span>
                      <p>Recibe liquidaciones por email y ahorra papel.</p>
                    </div>

                    <button
                      pButton
                      label="Activar"
                      class="p-button-sm p-button-success p-button-rounded"
                      (click)="activar()"
                    ></button>
                  </div>
                </div>
              }

              <div class="field mb-4">
                <label class="block mb-1 text-sm font-medium text-secondary">
                  Tipo de Suministro
                </label>

                <p-select
                  [options]="supplies"
                  formControlName="supplyType"
                  optionLabel="supplyName"
                  optionValue="value"
                  placeholder="Seleccione suministro"
                  class="w-full custom-select"
                  (onChange)="onSupplyTypeChange($event)"
                  appendTo="body"
                >
                </p-select>
              </div>

              @if (showCalendar === true) {
                <div formArrayName="comparativas" class="date-list">
                  <div
                    *ngFor="let item of comparativas.controls; let i = index"
                    [formGroupName]="i"
                    class="date-row-group"
                  >
                    <div class="card-title">
                      <lucide-icon name="Activity" [size]="18"></lucide-icon>
                      <h4>
                        Rangos de Fecha
                        <span
                          class="custom-tooltip-trigger"
                          data-tooltip="El rango máximo de selección es de 2 años."
                        >
                          <i class="info-icon-circle">i</i>
                        </span>
                      </h4>
                      <div class="ml-auto" title="Cambiar vista" (click)="switchCalendar()">
                        <lucide-icon
                          style="cursor: pointer"
                          name="list-icon"
                          [size]="18"
                        ></lucide-icon>
                      </div>
                    </div>

                    <div class="input-grid">
                      <div class="field">
                        <label class="block mb-1 text-sm font-medium text-secondary">Inicio</label>
                        <p-datepicker
                          formControlName="inicio"
                          dateFormat="dd/mm/yy"
                          [showIcon]="true"
                          (onSelect)="onDateChange(i, 'inicio'); clearDateRangeYearWarning()"
                          (onYearChange)="onInicioYearChange($event, i)"
                          (onMonthChange)="onInicioMonthChange($event, i)"
                          (onClose)="clearDateRangeYearWarning()"
                          iconDisplay="input"
                          [minDate]="minDate"
                          [maxDate]="comparativas.at(i).get('fin')?.value || maxDate"
                          placeholder="dd/mm/aaaa"
                          appendTo="body"
                          styleClass="w-full"
                        >
                        </p-datepicker>
                      </div>

                      <div class="field">
                        <label class="block mb-1 text-sm font-medium text-secondary">Fin</label>
                        <p-datepicker
                          formControlName="fin"
                          dateFormat="dd/mm/yy"
                          [showIcon]="true"
                          (onSelect)="onDateChange(i, 'fin')"
                          [minDate]="comparativas.at(i).get('inicio')?.value || minDate"
                          [maxDate]="maxDate"
                          iconDisplay="input"
                          placeholder="dd/mm/aaaa"
                          appendTo="body"
                          styleClass="w-full"
                        >
                        </p-datepicker>
                        @if (showDateRangeYearWarning()) {
                          <small class="date-range-year-warning"
                            >El rango máximo permitido es de 2 años.</small
                          >
                        }
                      </div>
                    </div>
                  </div>
                </div>
              } @else {
                <div class="date-row-group">
                  <div class="card-title mb-3">
                    <lucide-icon name="Activity" [size]="18"></lucide-icon>
                    <h4>Fecha</h4>
                    <div class="ml-auto" title="Cambiar vista" (click)="switchCalendar()">
                      <lucide-icon
                        data-tooltip="Cambiar a modo calendario"
                        style="cursor: pointer"
                        name="calendar"
                        [size]="18"
                      >
                      </lucide-icon>
                    </div>
                  </div>
                  <div class="field">
                    <label class="block mb-1 text-sm font-medium text-secondary"></label>
                    <p-select
                      [options]="predefinedDateOptions"
                      formControlName="predefineDateOption"
                      optionLabel="label"
                      placeholder="Seleccione suministro"
                      class="w-full custom-select"
                      (onChange)="applyConfig()"
                      appendTo="body"
                    >
                      <ng-template #selectedItemDate let-selectedOption2>
                        <div class="flex align-items-center gap-2" *ngIf="selectedOption2">
                          <lucide-icon name="Droplets" [size]="14"></lucide-icon>
                          <span>{{ selectedOption2.label }}</span>
                        </div>
                      </ng-template>
                    </p-select>
                  </div>
                </div>
              }
            </section>

            <div class="summary-card">
              <div class="card-title">
                <lucide-icon name="Activity" [size]="18"></lucide-icon>
                <h4>Resumen de la búsqueda</h4>
              </div>

              <div class="summary-rows">
                <div class="s-row">
                  <span class="s-label">Precio medio en el período</span>
                  <span class="s-value">{{ resumen.avg }} {{ resumen.units }}</span>
                </div>

                <div class="s-row-complex">
                  <div class="s-label">Precio máximo:</div>
                  <div class="s-sublabel">{{ resumen.maxLabel }}</div>
                  <div class="s-value">{{ resumen.maxV }} {{ resumen.units }}</div>
                </div>

                <div class="s-row-complex">
                  <div class="s-label">Precio mínimo:</div>
                  <div class="s-sublabel">{{ resumen.minLabel }}</div>
                  <div class="s-value">{{ resumen.minV }} {{ resumen.units }}</div>
                </div>

                <div class="s-row total">
                  <span class="s-label">Precio total del período</span>
                  <span class="s-value">{{ resumen.total }} {{ resumen.units }}</span>
                </div>
              </div>
            </div>

            <div class="action-footer">
              @if (showCalendar) {
                <p-button
                  severity="secondary"
                  outlined="true"
                  label="Limpiar"
                  (onClick)="resetConfig()"
                  class="w-100"
                  styleClass="w-100 btn-clear-filters"
                  [style]="{ width: '100%' }"
                />

                <span
                  pTooltip="Por favor, seleccione un rango de fechas válido."
                  [tooltipDisabled]="!configForm.invalid"
                  tooltipPosition="top"
                >
                  <p-button
                    severity="primary"
                    outlined="true"
                    label="Aplicar filtros"
                    [disabled]="configForm.invalid"
                    (onClick)="applyConfig()"
                    class="w-100"
                    styleClass="w-100 btn-apply-filters"
                    [style]="{ width: '100%' }"
                  />
                </span>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <div>
      @if (loading()) {
        <p-card class="mt-3 mb-3 mt-xl-0 my-xl-0">
          <div class="d-flex fw-bold mb-2 fs-5 align-items-center">
            <div class="w-100"><span class="me-2"> Listado de liquidaciones</span></div>
          </div>
          <div class="skeleton-table" aria-busy="true">
            <div class="skeleton-table-header" aria-hidden="true">
              <p-skeleton width="60%" height="12px" />
              <p-skeleton width="85%" height="12px" />
              <p-skeleton width="75%" height="12px" />
              <div class="d-flex justify-content-center w-100">
                <p-skeleton width="70%" height="12px" />
              </div>
            </div>
            @for (row of [1, 2, 3, 4, 5, 6]; track row) {
              <div class="skeleton-table-row" aria-hidden="true">
                <p-skeleton width="18px" height="18px" borderRadius="4px" />
                <p-skeleton width="85%" height="12px" />
                <p-skeleton width="75%" height="12px" />
                <div class="d-flex justify-content-center align-items-center w-100">
                  <p-skeleton shape="circle" size="2.5rem" />
                </div>
              </div>
            }
          </div>
        </p-card>
      } @else {
        <p-card class="mt-3 mb-3 mt-xl-0 my-xl-0 billings-table-card">
          <div class="d-flex fw-bold fs-5 align-items-center">
            <div class="w-100">
              <span class="me-2"> Listado de liquidaciones</span>
              <p-button variant="text" (click)="op.toggle($event)" icon="pi pi-question-circle" />
            </div>
          </div>
          <p-popover #op>
            <span
              >Puedes seleccionar/deseleccionar varias filas para descargar mediante click
              izquierdo.</span
            >
          </p-popover>
          @if (!tableInitialized()) {
            <div class="billings-table-skeleton-overlay skeleton-table" aria-busy="true">
              <div class="skeleton-table-header" aria-hidden="true">
                <p-skeleton width="60%" height="12px" />
                <p-skeleton width="85%" height="12px" />
                <p-skeleton width="75%" height="12px" />
                <div class="d-flex justify-content-center w-100">
                  <p-skeleton width="70%" height="12px" />
                </div>
              </div>
              @for (row of [1, 2, 3, 4, 5, 6]; track row) {
                <div class="skeleton-table-row" aria-hidden="true">
                  <p-skeleton width="18px" height="18px" borderRadius="4px" />
                  <p-skeleton width="85%" height="12px" />
                  <p-skeleton width="75%" height="12px" />
                  <div class="d-flex justify-content-center align-items-center w-100">
                    <p-skeleton shape="circle" size="2.5rem" />
                  </div>
                </div>
              }
            </div>
          }
          <p-table
            #settlementTable
            [value]="settlementsSignal()"
            selectionMode="multiple"
            [styleClass]="useFixedTableRowHeight() ? 'billings-table-rows-fixed' : ''"
            [(selection)]="settlementsSelected"
            stripedRows
            [scrollable]="settlementsTableScrollable"
            [scrollHeight]="settlementsTableScrollHeight"
            [size]="'small'"
            [tableStyle]="settlementsTableStyle"
            [rowsPerPageOptions]="settlementsTableRowsPerPageOptions"
            [paginator]="true"
            [rows]="rows"
            [first]="first"
            [lazy]="true"
            sortField="invoiceDate"
            [sortOrder]="-1"
            [showCurrentPageReport]="settlementsTableShowCurrentPageReport"
            [showPageLinks]="settlementsTableShowPageLinks"
            [showFirstLastIcon]="settlementsTableShowFirstLastIcon"
            [paginatorStyleClass]="settlementsTablePaginatorStyleClass"
            (onLazyLoad)="loadSettlementsLazy($event)"
            [totalRecords]="totalRecords()"
            currentPageReportTemplate="{last} de {totalRecords}"
          >
            <ng-template pTemplate="header" let-columns>
              @if (isNarrowViewport()) {
                <tr>
                  <th>
                    <div class="d-flex align-items-center justify-content-between w-100 gap-2">
                      <span>Liquidación</span>
                      <div class="d-flex align-items-center gap-2">
                        <span
                          class="small cursor-pointer color-download-lucide-icon"
                          [class.opacity-50]="!settlementsSelected.length || isDownloading()"
                          [class.pointer-events-none]="
                            !settlementsSelected.length || isDownloading()
                          "
                          (click)="
                            !isDownloading() &&
                              settlementsSelected.length &&
                              downloadSelectedSettlements()
                          "
                        >
                          @if (isDownloading()) {
                            Descargando...
                          } @else {
                            Descargar todo
                          }
                        </span>
                        <lucide-icon
                          (click)="op2Mobile.toggle($event)"
                          name="help-circle"
                          [size]="16"
                          class="cursor-pointer text-secondary"
                        ></lucide-icon>
                        <p-popover #op2Mobile>
                          <span>Selecciona filas con el checkbox y pulsa «Descargar todo».</span>
                        </p-popover>
                      </div>
                    </div>
                  </th>
                </tr>
              } @else {
                <tr>
                  <th
                    style="width: 15%"
                    class="d-none d-md-table-cell d-lg-table-cell d-xl-table-cell"
                  >
                    <div class="d-flex">
                      <p-tableHeaderCheckbox />

                      <lucide-icon
                        (click)="op2.toggle($event)"
                        [name]="isDownloading() ? 'loader' : 'download'"
                        class="color-download-lucide-icon ms-auto cursor-pointer"
                        [class.animate-spin]="isDownloading()"
                        (click)="
                          !isDownloading() &&
                            settlementsSelected.length &&
                            downloadSelectedSettlements()
                        "
                        [class.opacity-50]="
                          !settlementsSelected || settlementsSelected.length <= 0 || isDownloading()
                        "
                        [class.pointer-events-none]="
                          !settlementsSelected || settlementsSelected.length <= 0 || isDownloading()
                        "
                      ></lucide-icon>
                      <p-popover #op2>
                        <span>
                          @if (isDownloading()) {
                            Descargando...
                          } @else {
                            Descargar liquidaciones seleccionadas
                          }
                        </span>
                      </p-popover>
                    </div>
                  </th>

                  <th
                    style="width: 21.25%"
                    pSortableColumn="supplyType"
                    class="d-none d-md-table-cell d-lg-table-cell d-xl-table-cell"
                    field="type"
                  >
                    Suministro
                    <p-sortIcon field="supplyType" />
                  </th>
                  <th
                    style="width: 21.25%"
                    class="d-none d-md-table-cell d-lg-table-cell d-xl-table-cell"
                  >
                    Periodo
                  </th>
                  <!-- Ordenación temporalmente deshabilitada: pSortableColumn="totalAmount" -->
                  <th
                    style="width: 21.25%"
                    class="d-none d-md-table-cell d-lg-table-cell d-xl-table-cell text-end"
                  >
                    Importe total
                    <!-- <p-sortIcon field="totalAmount" /> -->
                  </th>
                  <th
                    style="width: 21.25%"
                    class="d-none text-center d-md-table-cell d-lg-table-cell d-xl-table-cell"
                    field="descarga"
                  >
                    Descarga liquidación (PDF)
                  </th>
                </tr>
              }
            </ng-template>
            <ng-template
              pTemplate="body"
              let-settlement
              let-columns="columns"
              let-rowIndex="rowIndex"
            >
              @if (isNarrowViewport()) {
                <tr [pSelectableRow]="settlement" [pSelectableRowIndex]="rowIndex">
                  <td [class.billings-table-td-fixed]="useFixedTableRowHeight()">
                    <div class="d-flex align-items-center w-100 gap-2">
                      <p-tableCheckbox [value]="settlement" />
                      <div class="flex-grow-1 text-center min-w-0 px-1">
                        <div class="fw-medium text-break">{{ settlement.supplyType }}</div>
                        <small class="text-secondary d-block">
                          {{ dateSpanishFormat(settlement.initDate) }} -
                          {{ dateSpanishFormat(settlement.endDate) }}
                        </small>
                        <small class="text-secondary d-block">
                          {{ spanishFormat(settlement.totalAmount) }} €
                        </small>
                      </div>
                      <p-button
                        [disabled]="isDownloading()"
                        (click)="downloadPdf(settlement)"
                        icon="pi pi-download"
                        [rounded]="true"
                      />
                    </div>
                  </td>
                </tr>
              } @else {
                <tr [pSelectableRow]="settlement" [pSelectableRowIndex]="rowIndex">
                  <td [class.billings-table-td-fixed]="useFixedTableRowHeight()">
                    <p-tableCheckbox [value]="settlement" />
                  </td>

                  <td [class.billings-table-td-fixed]="useFixedTableRowHeight()">
                    {{ settlement.supplyType }}
                  </td>
                  <td [class.billings-table-td-fixed]="useFixedTableRowHeight()">
                    {{ dateSpanishFormat(settlement.initDate) }} -
                    {{ dateSpanishFormat(settlement.endDate) }}
                  </td>
                  <td class="text-end" [class.billings-table-td-fixed]="useFixedTableRowHeight()">
                    {{ spanishFormat(settlement.totalAmount) }} €
                  </td>
                  <td
                    class="text-center"
                    [class.billings-table-td-fixed]="useFixedTableRowHeight()"
                  >
                    <p-button
                      [disabled]="isDownloading()"
                      (click)="downloadPdf(settlement)"
                      icon="pi pi-download"
                      [rounded]="true"
                    />
                  </td>
                </tr>
              }
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="5">Ningun resultado encontrado.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      }
    </div>
  </main>
</div>
